import axios from 'axios'
import { APROVAR_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function aprovarFechamentoCaixa (fechamentoCaixaId, observacao, codigoEmpresa) {
  const url = `${URL}/fechamento-caixa-usuario/${fechamentoCaixaId}/empresa/${codigoEmpresa}/aprovar`;
  return dispatch => axios.post(url, { observacao }, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type:APROVAR_FECHAMENTO_CAIXA ,
        payload: response
      })
  );
}
